import { client } from '@/services/api/axios.ts';
import { useQuery } from '@tanstack/react-query';
import { DeviceTypeCodes } from '@/features/devices/schemas/devices.schemas.ts';

type DeviceFieldId = number;

export type GetPlantControlPanelOverviewResponse = {
  chart: {
    time: string;

    [key: `${DeviceTypeCodes}:${DeviceFieldId}`]: number | string;
  }[];
  currentPower: {
    batteryPower: number;
    batterySoC: number;
    consumptionPower: number;
    gridPower: number;
    mqttStatus: -1 | 0 | 1;
  };
};

export const useGetPlantControlPanelOverviewQuery = ({ plantId }: { plantId: string }) => {
  return useQuery({
    queryKey: ['plants', plantId, 'control-panel'],
    queryFn: async () => {
      const { data } = await client.get<{
        body: GetPlantControlPanelOverviewResponse;
      }>(`/plants/${plantId}/control-panel`);

      return data.body;
    },
    retry: 1,
    staleTime: 1000 * 15,
    refetchInterval: 1000 * 15,
    enabled: Boolean(plantId),
  });
};
